import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { Collapse } from 'react-bootstrap';
import { OrderRequestFiles } from "../../request-details-files.component";
import { RequestOnBehalfDetails } from "../../request-on-behalf-details.component";
import Translation from "../../../../../common/translation/translation.component";
import Icons from '../../../../../icon';
import { ORDER_STATUS, CIRCUIT_STATUS } from '../../../../../../constants/external-constants';

export class ChangeUserDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showUserDetails: false
        };
    }

    handleShow = () => {
        this.setState({
            show: true
        });
    }
    editRequest = (orderStatusId, endUserId, requestorId) => {
        const editableRequest = (orderStatusId === ORDER_STATUS.waitingForAuthorization || orderStatusId === ORDER_STATUS.open);

        var employeeId = sessionStorage.getItem('EmployeeID');
        const isRequestOwner = (endUserId == employeeId) || (requestorId == employeeId);
        const showUpdateRequestLink = this.props.history.location.pathname.match(/Inventory.*/) === null ? true : false;

        return editableRequest && isRequestOwner && showUpdateRequestLink;
    }
    render() {
        const { openRequestModal, data } = this.props;
        const { Order: { RequestType: { RequestTypeID, RequestType }, OrderStatusId, EndUserId, RequestorId } } = data || {};
        var IsInService = data.Subscription.CircuitStatus == CIRCUIT_STATUS.inService.name ? true : false;
        return (
            <div>                
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" />
                    {this.editRequest(OrderStatusId, EndUserId, RequestorId) ?  
                           <Icons
                           customClassName="pen-to-square"
                           name="pen-to-square"
                           size="20px"
                           containerClass="icon-circle-plus-container"
                           onClick={() =>{openRequestModal(RequestTypeID, RequestType)}} 
                           labelValue={"Update Order Request"}
                           labelClass="order-detail-edit-label"                                                              
                       />
                        : null 
                    }
                </h4>
                <div className="order-detail-location">
                    <div className="order-detail-number-container">
                        <div className="order-title">
                            <Translation translationKey="order_number" />
                        </div>
                        <div className="order-label">
                            {data.Order.OrderNumber}
                        </div>
                    </div>
                    {data.Order.IsRequestedInBehalf ?
                        <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} />
                        : null}
                    <h5 className="order-detail-location-title"><Translation translationKey="subscription_upper" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td className="mobile-number-label"><Translation translationKey="mobile_phone_number" /></td>
                                <td className="mobile-number-label">{data.Circuit.CircuitCode}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className={data.Subscription.CircuitStatus == CIRCUIT_STATUS.inService.name ? "status-inservice" : data.Subscription.CircuitStatus == CIRCUIT_STATUS.suspended.name ? "status-suspended" : ""} >{data.Subscription.CircuitStatus}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription.VendorName}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription.PlanDetails.PlanName ?
                                    data.Subscription.PlanDetails.PlanName :
                                    <Translation translationKey="no_plan_available" />}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription && data.Subscription.SubscriptionDetailDevice ?
                                    data.Subscription.SubscriptionDetailDevice.EquipmentModel :
                                    <Translation translationKey="no_device_available" />} </td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title">TRANSFER TO NEW SUBSCRIBER</h5>
                    {/* <h5 className="order-detail-location-title"><Translation translationKey="transfer_to" /></h5> */}
                    {/* <h5 className="order-detail-location-title"><Translation translationKey="new_subscriber" /></h5> */}
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="name" /></td>
                                <td>{data.NewRequest.User.LastName}, {data.NewRequest.User.FirstName} {data.NewRequest.User.MiddleName}</td>
                            </tr>
                            <tr>
                                <td></td>
                                 <td>
                                    <a onClick={() => this.setState({ showUserDetails: !this.state.showUserDetails })} className="order-action-link">
                                    {this.state.showUserDetails ? <Translation translationKey="hide_details" /> : <Translation translationKey="show_details" />}
                                    </a>
                                    <Collapse in={this.state.showUserDetails}>
                                        <div className="request-details-hidden-sec">
                                            <p className="request-details-sec-val">{data.NewRequest.User.Email}</p>
                                            <p className="request-details-sec-val">{data.NewRequest.User.Location.LocationSite + " - " + data.NewRequest.User.Location.LocationCity + ", " + data.NewRequest.User.Location.CountryName}</p>
                                        </div>
                                    </Collapse>
                                </td> 
                            </tr>
                            <tr>
                                <td><Translation translationKey="purpose_of_use" /></td>
                                <td>{data.BusinessJustification.PurposeOfUse}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_case" /></td>
                                <td>{data.BusinessJustification.BusinessJustification}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_justification" /></td>
                                <td>{data.BusinessJustification.BusinessJustification}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>{data.BusinessJustification.AdditionalInformation}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    }
}